var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-filter-search",
      class: [_vm.isSearchOpen ? "c-filter-search--active" : ""]
    },
    [
      _c(
        "form",
        {
          staticClass: "c-filter-search__form u-bg-color-brand-two-whiten-10",
          class: [_vm.isSearchOpen ? "c-filter-search__form--active" : ""],
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.updateValue($event)
            }
          }
        },
        [
          _c(
            "label",
            { staticClass: "visually-hidden", attrs: { for: "searchList" } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.internalValue,
                expression: "internalValue"
              }
            ],
            ref: "searchInput",
            staticClass: "c-filter-search__input",
            attrs: {
              id: "searchList",
              name: "searchList",
              type: "placeholder"
            },
            domProps: { value: _vm.internalValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.internalValue = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "c-filter-search__buttons" }, [
            _c(
              "div",
              {
                staticClass:
                  "c-filter-search__button-items c-filter-search__button-items--order-last"
              },
              [
                _c(
                  "button",
                  { staticClass: "c-filter-search__button-search" },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Search")
                    ]),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        staticClass: "c-filter-search__button-icon",
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#search"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.internalValue.length > 0
              ? _c("div", { staticClass: "c-filter-search__button-items" }, [
                  _c(
                    "button",
                    {
                      staticClass: "c-filter-search__button-clear",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.clearInput($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v("Clear search Box")
                      ]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "c-filter-search__button-icon",
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#close"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-filter-search__toggle",
          on: { click: _vm.toggleSearchInput }
        },
        [
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v("Toggle search box visibility")
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "c-filter-search__open-icon",
              attrs: { "aria-hidden": "true", focusable: "false" }
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#search"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "c-filter-search__close-icon",
              attrs: { "aria-hidden": "true", focusable: "false" }
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#close"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50d1943e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50d1943e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_filter/filter-search/FilterSearch.vue
// module id = 626
// module chunks = 0